// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminExecutionRuntimeValues = {
  values: {
    accessMethodWeb: "Web",
    accessMethodSsh: "SSH",
    accessMethodRdp: "RDP",
    accessMethodVnc: "VNC",
    accessMethodPortMapping: "端口映射",
    noAccessEndpoints: "暂无访问端点",
    workspaceAccessOnly: "仅运行节点可访问",
    providerTypeLocal: "本地",
    providerTypeCenter: "资产中心",
    executionProviderTypeLocal: "本地执行",
    executionProviderTypeCenter: "执行底座",
    providerTypeLocalRuntime: "本地运行时",
    providerKeyLocalRuntimeDocker: "本地运行时 Docker",
    providerKeyLocalRuntimeKvm: "本地虚机运行",
    providerKeyAliyunAckContainer: "阿里云 ACK 容器",
    providerKeyAliyunEcsKvm: "阿里云 ECS KVM",
    providerKeyUnknown: "未定义提供方",
    sourceTypeQuestionEditorPracticalDebug: "题目编辑器实操调试",
    sourceTypeQuestionEditorAttackDebug: "题目编辑器攻防调试",
    sourceTypeRuntimeDocker: "运行时 Docker 实例",
    objectTypeQuestionEditorDebug: "题目编辑调试实例",
    objectTypeDockerInstance: "独立容器实例",
    environmentTypeDebug: "调试环境",
    instanceKindBusiness: "业务实例",
    instanceKindDebug: "调试实例",
    instanceKindRuntime: "运行时实例",
    instanceKindPractical: "容器实训实例",
    instanceKindVm: "虚机实例",
    instanceKindRuntimeVm: "运行时虚机实例",
    actionCreateEnvironment: "环境实例创建",
    actionCreateDocker: "容器实例创建",
    actionImportTar: "Tar 导入镜像",
    actionImportAsset: "资产导入镜像",
    actionBuildDockerfile: "Dockerfile 构建",
  },
} as const;
